import React from "react";

const UserContext = React.createContext({
  currentUser: null,
  appVersion: "",
  signIn: i => {},
  signOut: i => {},
  impersonate: i => {},
  clearImpersonation: i => {},
  theme: null,
  changeTheme: i => {},
  customerFilter: null,
  setCustomerFilter: i => {},
  myCustomerAccounts: [],
  prospectFilter: null,
  setProspectFilter: i => {},
  shoppingCart: null,
  setShoppingCart: i => {},
  activeCarts: null,
  setActiveCarts: i => {},
  cartMenuOpen: null,
  setCartMenuOpen: i => {},
  openLineItem: null,
  setOpenLineItem: i => {},
  toggleCartOpen: i => {},
  pinned: null,
  setPinned: i => {}
});

export default UserContext;
